var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UserProfile",
    transform: "translate(-4005 -10487)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(4005 10487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Client",
    transform: "translate(4005 10487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M20,40A20,20,0,1,1,40,20,20,20,0,0,1,20,40ZM20,2.1A17.9,17.9,0,1,0,37.9,20,17.9,17.9,0,0,0,20,2.1Zm0,32.6h0A14.685,14.685,0,0,1,7.748,28.114l-.182-.264v-.333c0-4.883,8.8-6.867,12.417-6.867s12.35,1.983,12.417,6.867v.333l-.183.267A14.683,14.683,0,0,1,20,34.7Zm0-15.55a6.667,6.667,0,1,1,6.667-6.667A6.667,6.667,0,0,1,20,19.15Z",
    transform: "translate(0)",
    fill: "#8cc739"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/UserProfile.926407fdd2b96c94312e381656c902c6.svg";
export { ForwardRef as ReactComponent };